export const GET_SERVICE_RECORDS = "GET_SERVICE_RECORDS";
export const GET_SERVICE_RECORDS_SUCCESS = "GET_SERVICE_RECORDS_SUCCESS";
export const GET_SERVICE_RECORDS_FAIL = "GET_SERVICE_RECORDS_FAIL";

export const SERVICE_RECORDS_BY_ID = "SERVICE_RECORDS_BY_ID";
export const SERVICE_RECORDS_BY_ID_SUCCESS = "SERVICE_RECORDS_BY_ID_SUCCESS";
export const SERVICE_RECORDS_BY_ID_FAIL = "SERVICE_RECORDS_BY_ID_FAIL";

export const ADD_SERVICE_RECORD = "ADD_SERVICE_RECORD";
export const ADD_SERVICE_RECORD_SUCCESS = "ADD_SERVICE_RECORD_SUCCESS";
export const ADD_SERVICE_RECORD_FAIL = "ADD_SERVICE_RECORD_FAIL";

export const DELETE_SERVICE_RECORD = "DELETE_SERVICE_RECORD";
export const DELETE_SERVICE_RECORD_SUCCESS = "DELETE_SERVICE_RECORD_SUCCESS";
export const DELETE_SERVICE_RECORD_FAIL = "DELETE_SERVICE_RECORD_FAIL";

export const UPDATE_SERVICE_RECORD = "UPDATE_SERVICE_RECORD";
export const UPDATE_SERVICE_RECORD_SUCCESS = "UPDATE_SERVICE_RECORD_SUCCESS";
export const UPDATE_SERVICE_RECORD_FAIL = "UPDATE_SERVICE_RECORD_FAIL";

export const SERVICE_RECORD_ADD_FILE = "SERVICE_RECORD_ADD_FILE";
export const SERVICE_RECORD_ADD_FILE_SUCCESS = "SERVICE_RECORD_ADD_FILE_SUCCESS";
export const SERVICE_RECORD_ADD_FILE_FAIL = "SERVICE_RECORD_ADD_FILE_FAIL";

export const SERVICE_RECORD_DELETE_FILE = "SERVICE_RECORD_DELETE_FILE";
export const SERVICE_RECORD_DELETE_FILE_SUCCESS = "SERVICE_RECORD_DELETE_FILE_SUCCESS";
export const SERVICE_RECORD_DELETE_FILE_FAIL = "SERVICE_RECORD_DELETE_FILE_FAIL";

export const GET_SERVICE_RECORD_LOGS = "GET_SERVICE_RECORD_LOGS";
export const GET_SERVICE_RECORD_LOGS_SUCCESS = "GET_SERVICE_RECORD_LOGS_SUCCESS";
export const GET_SERVICE_RECORD_LOGS_FAIL = "GET_SERVICE_RECORD_LOGS_FAIL";
